export const CREATE = 'CREATE'
export const UPDATE = 'UPDATE'
export const DELETE = 'DELETE'
export const FETCH_ALL = 'FETCH_ALL'
export const LIKE = 'LIKE'
export const LOGOUT = 'LOGOUT'
export const AUTH = 'AUTH'
export const AUTH_FAIL = 'AUTH_FAIL'
export const SENDBYEMAIL = 'SENDBYEMAIL'
export const POST_COUNT = 'POST_COUNT'
export const FETCH_PAG = 'FETCH_PAG'
export const START_LOADING = 'START_LOADING'
export const END_LOADING = 'END_LOADING'
export const STATUS = 'STATUS'

export const URL = ''
//const API_URL = 'http://localhost:5000'

export const API_URL = 'https://minhkhapaint.com:5001'
export const AddColorCode = 'Thêm Mới'
export const Edit = 'Sửa'
export const Results = 'Kết quả'
export const Type = 'Loại Xe'
export const Category = 'Hãng Xe'
export const SelectCategory = 'Chọn Hãng Xe'
export const SelectType = 'Chọn Loại Xe'
export const SelectColorCode = 'Chọn Mã Màu'
export const Car = 'Ô tô'
export const Motor = 'Xe máy'
export const AddCategory = 'Hãng Khác'
export const FilterByCategory = 'Lọc theo hãng xe'
export const VehicleName = 'Tên Xe'
export const ColorCode = 'Mã Màu'
export const ColorCodeName = 'Tên Màu'
export const VehicleVersion = 'Loại xe, năm sx'
export const EnterColorCode = 'Nhập Mã Màu'
export const EnterColorCodeName = 'Nhập Tên Mã Màu'
export const EnterVersion = 'Nhập Phiên Bản'
export const EnterVolume = 'Nhập Khối Lượng'
export const CreatedDate = 'Ngày Tạo'
export const AreYouSureToDelete = 'Bạn có chắc muốn xóa không?'
export const AddColor = 'Thêm Màu Mới'
export const EditColor = 'Thay Đổi Màu'
export const Save = 'Lưu'
export const Total = 'Cộng dồn'
export const Volume = 'Từng Phần'
export const Version = 'Phiên Bản'
export const Percent = 'Phần trăm'
export const UpdateSuccess = 'Đã lưu những thay đổi'
export const DeleteSuccess = 'Đã xóa'
export const AddSuccess = 'Đã lưu'
export const GoBack = 'Quay lại'
export const View = 'Xem'
export const DashBoard = 'Quản Lý'
export const Close = 'Đóng'
export const Quantity = 'Khối Lượng (kg)'
export const ListColorCode = 'Danh Sách Mã Màu'
export const SearchByColorCode = 'Tìm Theo Mã Màu'
export const ExitColorCode = 'Mã màu này đã có rồi vui lòng nhập mã màu khác'

//export const API_URL = 'https://upload.nationallaserinstitute.com'
